<template>
  <v-app class="home">
    <v-layout row wrap>
      <v-flex xs12 pa-2>
        <h2> {{ activeUsername }} </h2>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Matches
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6 md3>
                    <small> Matches Played </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.activitiesEntered.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Wins </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.activitiesWon.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Losses </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.activitiesEntered.basic.value - stats.activitiesWon.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> W/L </small> <br>
                    <v-progress-circular
                      :value="winLossRatio * 100"
                      :color="winLossRatio > 0.50 ? 'green' : 'red'"
                    >
                    </v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  KDA
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6 md3>
                    <small> Kills </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.kills.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Deaths </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.deaths.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Assists </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.assists.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Efficiency </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.efficiency.basic.value.toFixed(2) }} </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Blockers/Primeval
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6 md3>
                    <small> Small </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.smallBlockersSent.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Medium </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.mediumBlockersSent.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Large </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.largeBlockersSent.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Primeval Damage </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.primevalDamage.basic.value }} </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Invading
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6 md3>
                    <small> Invasions </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.invasions.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Invasion Kills </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.invasionKills.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Invader Kills </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.invaderKills.basic.value }} </span>
                  </v-flex>
                  <v-flex xs6 md3>
                    <small> Deaths While Invading </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.invaderDeaths.basic.value }} </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Motes
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs4>
                    <small> Denied </small> <br>
                    <span class="display-1 font-weight-light"> {{ this.motes.denied}} </span>
                  </v-flex>
                  <v-flex xs4>
                    <small> Deposited </small> <br>
                    <span class="display-1 font-weight-light"> {{ this.motes.deposited }} </span>
                  </v-flex>
                  <v-flex xs4>
                    <small> Lost </small> <br>
                    <span class="display-1 font-weight-light"> {{ this.motes.lost }} </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Misc. Stats
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs3>
                    <small> Blocker Kills </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.blockerKills.basic.value }} </span>
                  </v-flex>
                  <v-flex xs3>
                    <small> Precision Kills </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.precisionKills.basic.value }} </span>
                  </v-flex>
                  <v-flex xs3>
                    <small> Hours Played </small> <br>
                    <span class="display-1 font-weight-light"> {{ parseFloat(stats.secondsPlayed.basic.value / 60 / 60).toFixed(2) }} </span>
                  </v-flex>
                  <v-flex xs3>
                    <small> Most Kills in One Match </small> <br>
                    <span class="display-1 font-weight-light"> {{ stats.bestSingleGameKills.basic.value }} </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 pa-2>
            <v-card toolbar>
              <v-toolbar flat>
                <v-toolbar-title>
                  Weapon Distribution
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <weapon-bar-chart :chart-data="weaponChartCollection" :height="250"></weapon-bar-chart>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
/* eslint-disable */
import { db } from '../main';
import WeaponBarChart from './mixins/charts/WeaponBarChart';
const getRandomColor = () => { return "rgb(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255); }
import { startCase } from 'lodash';

export default {
  name: 'Home',
  components: {
    WeaponBarChart,
  },
  data() {
    return {
      starred: [],
      weaponChartCollection: {
        labels: [],
        datasets: [
          {
            label: 'Kills',
            backgroundColor: [],
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters.users;
    },
    stats() {
      return this.$store.getters.stats;
    },
    activeUsername() {
      return this.$store.getters.activeUsername;
    },
    motes() {
      return {
        denied: this.stats.motesDenied.basic.value,
        deposited: this.stats.motesDeposited.basic.value,
        lost: this.stats.motesLost.basic.value
      }
    },
    winLossRatio() {
      return (
        1 -
        (this.stats.activitiesEntered.basic.value -
          this.stats.activitiesWon.basic.value) /
          this.stats.activitiesEntered.basic.value
      ).toFixed(2);
    },
    weapons() {
      let tmp = [];
      let weaponStatEntries = Object.keys(this.stats).forEach((stat, index) => {
        if (stat.includes('weaponKills')) {
          tmp.push({ name: stat.substring(11), value: this.stats[stat].basic.value })
        }
      });
      return tmp.sort((a, b) => b.value - a.value);
    }
  },
  firestore() {
    return {
      starred: db.collection("starred")
    };
  },
  created() {
    const id = this.$route.params.id;
    const platform = this.$route.params.platform;
    this.$store.dispatch('loadUserStats', { user: id, platform });
    this.$store.dispatch('loadUserName', { user: id, platform});
    this.fillWeaponChartData();
  },
  methods: {
    fillWeaponChartData() {
      console.log(this.weapons);
      this.weapons.forEach((weapon, index) => {
        this.weaponChartCollection.labels.push(startCase(weapon.name));
        this.weaponChartCollection.datasets[0].data.push(weapon.value);
        this.weaponChartCollection.datasets[0].backgroundColor.push(getRandomColor());
      });
      this.$forceUpdate();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css");
</style>



// WEBPACK FOOTER //
// src/components/User.vue